import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { NEWS } from "../data/praxis";
import { getConsent } from "../utils/consent";

const STORAGE_KEY = "praxis_news_seen_v1";
const SESSION_KEY = "praxis_news_dismissed_session";

export default function NewsModal() {
  const [open, setOpen] = useState(false);
  const [dontShow, setDontShow] = useState(false);

  useEffect(() => {
    const shouldSkip = () =>
      localStorage.getItem(STORAGE_KEY) ||
      sessionStorage.getItem(SESSION_KEY);

    let timer = null;
    const schedule = () => {
      if (timer || shouldSkip()) return;
      timer = setTimeout(() => {
        if (!shouldSkip()) setOpen(true);
      }, 60000); // 60 Sekunden (1 Minute) Verzögerung
    };

    // Falls Consent schon vorhanden ist → Timer sofort starten
    if (getConsent()) schedule();

    const handler = () => {
      if (getConsent()) schedule();
    };
    window.addEventListener("consent-changed", handler);
    return () => {
      if (timer) clearTimeout(timer);
      window.removeEventListener("consent-changed", handler);
    };
  }, []);

  const close = () => {
    if (dontShow) localStorage.setItem(STORAGE_KEY, "1");
    // immer für die Session merken, dass User das Popup geschlossen hat
    sessionStorage.setItem(SESSION_KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" data-testid="news-modal">
      <div className="modal-card">
        <button
          className="modal-close"
          onClick={close}
          aria-label="Schließen"
          data-testid="news-modal-close"
        >
          <X size={20} />
        </button>
        <span className="badge">{NEWS.badge}</span>
        <h2>{NEWS.title}</h2>
        <p>{NEWS.text}</p>
        <div className="modal-actions">
          <Link
            to={NEWS.link}
            className="btn btn-gold"
            onClick={close}
            data-testid="news-modal-cta"
          >
            {NEWS.cta}
          </Link>
          <button className="btn btn-outline" onClick={close} data-testid="news-modal-dismiss">
            Später
          </button>
        </div>
        <label className="dont-show">
          <input
            type="checkbox"
            checked={dontShow}
            onChange={(e) => setDontShow(e.target.checked)}
            data-testid="news-dont-show-checkbox"
          />
          Nicht mehr anzeigen
        </label>
      </div>
    </div>
  );
}
